// extracted by mini-css-extract-plugin
module.exports = {"search_box":"index-module--search_box--1gSNb","home_box":"index-module--home_box--3SWmn","list_item":"index-module--list_item--h3Xdi"};